// extracted by mini-css-extract-plugin
export default {"chat_section_wrapper":"ChatSection_chat_section_wrapper__-6BGE"};